import React from 'react';
import { motion } from 'framer-motion';

interface LanguageToggleProps {
  currentLanguage: 'en' | 'zh';
  onToggle: () => void;
}

export const LanguageToggle: React.FC<LanguageToggleProps> = ({
  currentLanguage,
  onToggle
}) => {
  return (
    <motion.button
      onClick={onToggle}
      className="language-toggle"
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
    >
      <span className={currentLanguage === 'en' ? 'active' : ''}>EN</span>
      <span className="separator">|</span>
      <span className={currentLanguage === 'zh' ? 'active' : ''}>中</span>
    </motion.button>
  );
}; 